module.exports = __webpack_public_path__ + "static/media/IMG_7378-min.70a24537.jpg";